import React from 'react';

export const PageLoaderContext = React.createContext(false);
